/*
 * Personal Digital Spaces LLC ("COMPANY") CONFIDENTIAL
 * Unpublished Copyright (c) 2025 Personal Digital Spaces LLC, All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains the property of COMPANY. The intellectual and technical concepts contained
 * herein are proprietary to COMPANY and may be covered by U.S. and Foreign Patents, patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material is strictly forbidden unless prior written permission is obtained
 * from COMPANY.  Access to the source code contained herein is hereby forbidden to anyone except current COMPANY employees, managers, contractors or partners who have executed
 * Confidentiality and Non-disclosure agreements explicitly covering such access.
 *
 * The copyright notice above does not evidence any actual or intended publication or disclosure  of  this source code, which includes
 * information that is confidential and/or proprietary, and is a trade secret, of  COMPANY.   ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC  PERFORMANCE,
 * OR PUBLIC DISPLAY OF OR THROUGH USE  OF THIS  SOURCE CODE  WITHOUT  THE EXPRESS WRITTEN CONSENT OF COMPANY IS STRICTLY PROHIBITED, AND IN VIOLATION OF APPLICABLE
 * LAWS AND INTERNATIONAL TREATIES.  THE RECEIPT OR POSSESSION OF  THIS SOURCE CODE AND/OR RELATED INFORMATION DOES NOT CONVEY OR IMPLY ANY RIGHTS
 * TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT  MAY DESCRIBE, IN WHOLE OR IN PART.
 */
import React from 'react'
import Styles from './styles.module.sass'
import FeatureLicenses from '../FeatureLicenses'
import InputText from '@/components/forms/InputText'

const VaultSetupForm = ({
  getLicensesIdsSelected,
  getVaultPricing,
  vaultFeature,
  vaultBinding
}) => {
  const handleOnChange = (key, price) => {
    getVaultPricing(+price)
  }
  const handleGetLicensesIdsSelected = (key, ids) => {
    getLicensesIdsSelected &&
    getLicensesIdsSelected({ [key]: ids })
  }

  return (
    <div>
      <FeatureLicenses
        defaultFeatureLicenses={false}
        feature={vaultFeature}
        getFeaturePrice={handleOnChange}
        getLicensesIdsSelected={handleGetLicensesIdsSelected}
        keyId={vaultFeature.keyId}
      />
      { vaultBinding &&
        <form className={Styles.formColumns}>
          <div className={Styles.mainColumn}>
            <div className={Styles.flexRow}>
              <InputText
                label="Vault name"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.name}
                readOnly
              />
              <InputText
                label="Storage type"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.storageType}
                readOnly
              />
              <InputText
                label="Work type"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.workType}
                readOnly
              />
            </div>
            <div className={Styles.flexRow}>
              <InputText
                label="URL"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.url}
                readOnly
              />
              <InputText
                label="Binding Id"
                className={`${Styles.inputField} ${Styles.inputPath}`}
                inputClass={Styles.input}
                value={vaultBinding.bindingId}
                readOnly
              />
            </div>
            <div className={Styles.flexRow}>
              <InputText
                label="Support contact"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.supportContact}
                readOnly
              />
            </div>
            <div className={Styles.flexRow}>
              <InputText
                label="Bucket name"
                className={Styles.inputField}
                inputClass={Styles.input}
                value={vaultBinding.bucketName}
                readOnly
              />
            </div>
          </div>
        </form>
      }
    </div>
  )
}

export default VaultSetupForm
